<template>
  <div>
    <v-toolbar dark height="50px">
      <img alt="Vue logo" src="../assets/hpt.gif" style="height:100%; padding-right:5px">
        <v-toolbar-title
          @click="redirectToHome"><strong>HPT Online</strong>
        </v-toolbar-title>

      <div class="flex-grow-1"></div>
      <v-toolbar-items v-if="isLoggedIn">
        <v-btn text @click="redirectToGames"><v-icon style="padding-right:5px">mdi-file-plus-outline</v-icon><span class="d-none d-sm-flex"> Nytt System</span></v-btn>
        <v-btn text @click="redirectToSystems"><v-icon style="padding-right: 5px;">mdi-file-multiple-outline</v-icon><span class="d-none d-sm-flex">Mina system</span></v-btn>
        <v-menu :open-on-hover="false" offset-y transition="slide-y-transition">
          <template v-slot:activator="{ on }">
            <v-btn color="success" v-on="on" small text style="font-size:20px;">
              <v-icon>mdi-account-circle</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-btn text @click="logoutAction">Logga ut</v-btn>
          </v-list>
        </v-menu>
      </v-toolbar-items>
      <v-toolbar-items v-else>
        <v-btn text @click="redirectToRegister">Skapa konto</v-btn>
        <v-btn text @click="redirectToLogin">Logga in</v-btn>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters(['isLoggedIn'])
  },
  methods: {
    redirectToHome () {
      this.$router.push('/home')
    },
    redirectToLogin () {
      this.$router.push('/login')
    },
    redirectToRegister () {
      this.$router.push('/register')
    },
    redirectToGames () {
      this.$router.push('/games')
    },
    redirectToSystems () {
      this.$router.push('/systems')
    },
    ...mapActions(['logoutAction'])
  }
}
</script>
